import React, { FunctionComponent, useRef, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

import {
  Avatar,
  Grid,
  Tab,
  Tabs
} from '@mui/material';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {
  StyledEditorNoTransl,
  StyledTextField,
  Typography
} from '../../interface';

import { EmailBlock } from '../../../models/EmailBlock';

import SunEditorCore from "suneditor/src/lib/core";

type BlockSettingsTitleText2ColProps = {
  forceClose: boolean;
  setActive: (e:boolean) => void;
  setBlock: (eb:EmailBlock) => void;
  block: EmailBlock;
};

export const BlockSettingsTitleText2Col: FunctionComponent<BlockSettingsTitleText2ColProps> = ({forceClose, block, setBlock, setActive}) => {
  const theme = useTheme();

  const [value, setValue] = useState<string>(block.string_value || '');
  const [titleValue, setTitleValue] = useState<string>(block.title_value || '');
  const [valueRight, setValueRight] = useState<string>(block.string_value_right || '');
  const [titleValueRight, setTitleValueRight] = useState<string>(block.title_value_right || '');

  const [mtop, setMtop] = useState<string>(block.settings?.mtop || '0px');
  const [mbot, setMbot] = useState<string>(block.settings?.mbot || '0px');
  const [border, setBorder] = useState<string>(block.settings?.border || '0px');

  const editor = useRef<SunEditorCore>();
  const [activeTab, setActiveTab] = useState<number>(0);
  const [isHidden, setIsHidden] = useState<boolean>(true);

  const getSunEditorInstance = (sunEditor: SunEditorCore) => {
    editor.current = sunEditor;
  };

  useEffect(() => {
    let new_block = block;

    new_block.string_value = value;
    new_block.title_value = titleValue;
    new_block.string_value_right = valueRight;
    new_block.title_value_right = titleValueRight;

    if (!new_block.settings) new_block.settings = {};
    new_block.settings.mtop = mtop;
    new_block.settings.mbot = mbot;
    new_block.settings.border = border;
    
    setBlock(new_block);
  }, [value, titleValue, valueRight, titleValueRight, mtop, mbot, border]);

  return (<Grid item container xs={12} sx={{border: '1px solid lightgrey', marginBottom: 1}} onMouseEnter={() => {setActive(true);}} onMouseLeave={() => {setActive(false);}}>
    <Grid item xs={12} sx={{marginBottom: 0.5, position: 'relative', minHeight: '32px'}} onClick={() => {
      if (!!isHidden) setIsHidden(!isHidden);
    }}>
      {!forceClose && isHidden && <Avatar sx={{cursor: 'pointer', position: 'absolute', right: 8, top: 8, zIndex: 1000, height: 24, width: 24}}><ExpandLessIcon /></Avatar>}
      {!forceClose && !isHidden && <Avatar sx={{cursor: 'pointer', position: 'absolute', right: 8, top: 8, zIndex: 1000, height: 24, width: 24}} onClick={() => {
        setIsHidden(!isHidden);
      }}><ExpandMoreIcon /></Avatar>}

      {(!!forceClose || isHidden) && <Typography sx={{paddingLeft: 1, paddingTop: 1}}>TitleText 2Col</Typography>}

      {!forceClose && !isHidden && <Tabs value={activeTab} sx={{backgroundColor: theme.palette.opacitated?.main_01}} onChange={(event: React.SyntheticEvent, newValue: number) => {setActiveTab(newValue);}}>
        <Tab label="Content" />
        <Tab label="Settings" />
      </Tabs>}
    </Grid>
    {!forceClose && !isHidden && <>
      {activeTab === 0 && <Grid container item xs={12} hidden={activeTab !== 0} sx={{paddingLeft: 1, paddingRight: 1}}>
        <Grid item xs={12}>
          <StyledTextField
            label="Title Left"
            value={titleValue}
            id="title_value"
            onChange={(v:string) => {setTitleValue(v);}}
            fullWidth
          />
        </Grid>
        <StyledEditorNoTransl
          label="Block content left"
          value={value}
          getSunEditorInstance={getSunEditorInstance}
          onChange={(ob:string) => {
            setValue(ob);
          }}
        />
        <Grid item xs={12}>
          <StyledTextField
            label="Title Right"
            value={titleValueRight}
            id="title_value"
            onChange={(v:string) => {setTitleValueRight(v);}}
            fullWidth
          />
        </Grid>
        <StyledEditorNoTransl
          label="Block content right"
          value={valueRight}
          getSunEditorInstance={getSunEditorInstance}
          onChange={(ob:string) => {
            setValueRight(ob);
          }}
        />
      </Grid>}
      {activeTab === 1 && <Grid item xs={12} hidden={activeTab !== 1} sx={{paddingLeft: 1, paddingRight: 1}}>
        <Grid item xs={12}>
          <StyledTextField
            label="Margin Top"
            value={mtop || '0px'}
            id="mtop"
            onChange={(v:string) => {setMtop(v);}}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            label="Margin Bottom"
            value={mbot || '0px'}
            id="mbot"
            onChange={(v:string) => {setMbot(v);}}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            label="Border Colour (empty/transparent = no border)"
            value={border || 'transparent'}
            id="border"
            onChange={(v:string) => {setBorder(v);}}
            fullWidth
          />
        </Grid>
      </Grid>}
    </>}
  </Grid>);
};